import React, { memo, useMemo } from 'react';
import { Pressable } from 'react-native';
import { useSafeAreaInsets } from 'react-native-safe-area-context';

import { SvgIcon } from '@/components/ui';
import { useScaling } from '@/hooks';
import { guardianColors } from '@/theme/colors';

import { useStyles } from './styles';

type MobileHeaderProps = {
  onBack: () => void;
  onEdit: () => void;
};

const MobileHeader = memo(function MobileHeader({ onBack, onEdit }: MobileHeaderProps) {
  const styles = useStyles();
  const { scale } = useScaling();
  const insets = useSafeAreaInsets();

  const backButtonStyle = useMemo(
    () => [styles.mobileBackButton, { top: insets.top + scale(2) }],
    [styles.mobileBackButton, insets.top, scale],
  );

  const rightButtonStyle = useMemo(
    () => [styles.mobileRightButton, { top: insets.top + scale(2) }],
    [styles.mobileRightButton, insets.top, scale],
  );

  return (
    <>
      <Pressable
        accessibilityRole="button"
        accessibilityLabel="Back"
        onPress={onBack}
        style={backButtonStyle}>
        <SvgIcon name="IcBackBlue" size={scale(24)} color={guardianColors['10']} />
      </Pressable>
      <Pressable
        accessibilityRole="button"
        accessibilityLabel="Edit player"
        onPress={onEdit}
        style={rightButtonStyle}>
        <SvgIcon name="IcEditAvatar" size={scale(24)} color={guardianColors['10']} />
      </Pressable>
    </>
  );
});

export default MobileHeader;
